import React, { useEffect, useState } from 'react'
import TwicImg from '@twicpics/react'
import '@twicpics/react/dist/twicpics.css'
import { getTwicPicsSource } from 'shared/utils'
import { breakpoints } from 'app/assets/styles'
import { twicPicsDomain } from 'app/common/utils'
import { Picture as ResponsivePicture } from 'react-responsive-picture'
import styled from 'styled-components'
import { toSrcSet } from 'shared/utils'
import DefaultHeroDesktop from 'shared/assets/images/default-homepage-hero-desktop.jpg'
import DefaultHeroMobile from 'shared/assets/images/default-homepage-hero-mobile.jpg'

type Props = {
    cropped?: boolean,
    singleImage?: boolean,
    imageUrlLandscape?: Array<string>,
    imageUrlPortrait?: Array<string>,
    imageUrlCropped?: Array<string>,
    imageUrl?: Array<string>,
    width?: string,
    height?: string,
    desktopRatio?: string,
    mobileRatio?: string,
    imageTitle?: string,
    mode?: string
}

const Picture = (props: Props) => {
    const {
        cropped,
        singleImage,
        imageUrlLandscape,
        imageUrlPortrait,
        imageUrlCropped,
        imageUrl,
        imageTitle,
        width = '100%',
        height,
        desktopRatio,
        mobileRatio,
        mode = 'contain'
    } = props

    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        window.addEventListener('resize', updateWindowDimensions)

        return () =>
            window.removeEventListener('resize', updateWindowDimensions)
    }, [])

    const updateWindowDimensions = () => {
        setWindowWidth(window.innerWidth)
    }

    const isMobile = windowWidth < breakpoints.medium
    const croppedSrc = getTwicPicsSource(imageUrlCropped, twicPicsDomain)
    const singleSrc = getTwicPicsSource(imageUrl, twicPicsDomain)
    const portraitSrc = getTwicPicsSource(imageUrlPortrait, twicPicsDomain)
    const landscapeSrc = getTwicPicsSource(imageUrlLandscape, twicPicsDomain)

    const useTwicPicsComponent =
        (cropped &&
            imageUrlCropped &&
            imageUrlCropped[0] &&
            imageUrlCropped[0].includes(twicPicsDomain)) ||
        (singleImage &&
            imageUrl &&
            imageUrl[0] &&
            imageUrl[0].includes(twicPicsDomain)) ||
        (isMobile &&
            imageUrlPortrait &&
            imageUrlPortrait[0] &&
            imageUrlPortrait[0].includes(twicPicsDomain)) ||
        (imageUrlLandscape &&
            imageUrlLandscape[0] &&
            imageUrlLandscape[0].includes(twicPicsDomain))

    return useTwicPicsComponent ? (
        <TwicImg
            src={
                cropped // if cropped parameter is passed in props
                    ? croppedSrc // we use the cropped image url
                    : singleImage // else if singleImage parameter is passed in props
                    ? singleSrc // we use the single image url (one image for desktop and mobile without distinction)
                    : isMobile // else if we have a mobile screen
                    ? portraitSrc // we use the portrait image url
                    : landscapeSrc // else it means we have a desktop screen so we use the landscape url
            }
            alt={imageTitle}
            ratio={isMobile ? mobileRatio : desktopRatio}
            width={width}
            height={height}
            mode={mode}
            placeholder="none"
            focus="auto"
        />
    ) : (
        <Image
            width={width}
            alt={imageTitle}
            sources={
                cropped
                    ? [
                          {
                              srcSet:
                                  imageUrlCropped &&
                                  imageUrlCropped.length > 0 &&
                                  toSrcSet(imageUrlCropped)
                          }
                      ]
                    : singleImage
                    ? [
                          {
                              srcSet:
                                  imageUrl &&
                                  imageUrl.length > 0 &&
                                  toSrcSet(imageUrl)
                          }
                      ]
                    : [
                          {
                              srcSet:
                                  imageUrlPortrait &&
                                  imageUrlPortrait.length > 0
                                      ? toSrcSet(imageUrlPortrait)
                                      : toSrcSet([DefaultHeroMobile]),
                              media: '(max-width: 992px)'
                          },
                          {
                              srcSet:
                                  imageUrlLandscape &&
                                  imageUrlLandscape.length > 0
                                      ? toSrcSet(imageUrlLandscape)
                                      : toSrcSet([DefaultHeroDesktop])
                          }
                      ]
            }
        />
    )
}

const Image = styled(ResponsivePicture)`
    width: ${props => (props.width ? props.width : '')};
`

export default Picture
